import { User } from '@yarmill/types';
import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function registerUser(user: User): AxiosPromise<boolean> {
  return axios.post('api/Account/Register/PostUserInfo', user);
}
